import React from 'react';
import PropTypes from 'prop-types';

import { FilePropType, MaterialPropType } from 'propTypes/common';

import Image from './Image';
import Video from './Video';
import VirtualTour from './VirtualTour';

const GalleryItem = ({ material, type }) => {
	switch (type) {
		case 'tours':
			return <VirtualTour {...material} />;
		case 'image':
			return <Image file={material} />;
		case 'video':
			return <Video material={material} />;
		default:
			return null;
	}
};

GalleryItem.propTypes = {
	material: PropTypes.oneOfType([FilePropType, MaterialPropType]).isRequired,
	type: PropTypes.oneOf(['tours', 'image', 'video']).isRequired
};

export default GalleryItem;
